import {
  ahmedPhoto,
  brandonEvansPhoto,
  brandonKleinPhoto,
  chrisDefour2Photo,
  chrisDefourPhoto,
  chrisNormanPhoto,
  darrenMoonPhoto,
  davidKitchenPhoto,
  dustinGrinerPhoto,
  ianGilmourPhoto,
  karaPhoto,
  karmaPhoto,
  krishnaPhoto,
  markVanRijmenamPhoto,
  matDiabPhoto,
  noamEppelPhoto,
  rajNarayaPhoto,
  robertoVelardePhoto,
  rossHenryPhoto,
} from 'Assets/_Legacy/Clients'

const CLIENTS = {
  IAN_GILMOUR: {
    fullName: 'Ian Gilmour',
    image: ianGilmourPhoto,
    positionHeld: 'Chairman at Al Forum',
  },
  BRANDON_KLEIN: {
    fullName: 'Brandon Klein',
    image: brandonKleinPhoto,
    positionHeld: 'NetworkOS, Co-founder',
  },
  BRANDON_EVANS: {
    fullName: 'Brandon Evans',
    image: brandonEvansPhoto,
    positionHeld: 'Guided, Co-founder',
  },
  CHRIS_DEFOUR: {
    fullName: 'Chris Defour',
    image: chrisDefourPhoto,
    positionHeld: 'CEO',
  },
  ROSS_HENRY: {
    fullName: 'Ross Henry',
    image: rossHenryPhoto,
    positionHeld: 'Founder',
  },
  CHRIS_NORMAN: {
    fullName: 'Chris Norman',
    image: chrisNormanPhoto,
    positionHeld: 'Lyfta, CTO',
  },
  DAVID_KITCHEN: {
    fullName: 'David Kitchen',
    image: davidKitchenPhoto,
    positionHeld:
      'Founder of FantasyInsiders, Creative Director at RotoGrinders',
  },
  ROBERTO_VELARDE: {
    fullName: 'Roberto Velarde',
    image: robertoVelardePhoto,
    positionHeld: 'Voicereel, Founder',
  },
  KRISHNA_SUBRAMANIAN: {
    fullName: 'Krishna Subramanian',
    image: krishnaPhoto,
    positionHeld: 'Creator.ai, Co-Founder',
  },
  DUSTIN_GRINER: {
    fullName: 'Dustin Griner',
    image: dustinGrinerPhoto,
    positionHeld: 'John Wayne Construction, Director of Strategy & Finance',
  },
  CHRIS_DEFOUR_2: {
    fullName: 'Chris Defour',
    image: chrisDefour2Photo,
    positionHeld: 'SaaSquash Technologies, President & Managing Partner',
  },
  AHMED_BAHGAT: {
    fullName: 'Ahmed Bahgat',
    image: ahmedPhoto,
    positionHeld: 'Tazawaj, Founder',
  },
  MATHIEU_DIAB: {
    fullName: 'Mathieu Diab',
    image: matDiabPhoto,
    positionHeld: 'Workaxle, Founder',
  },
  KARMA_SLOMIANSKI: {
    fullName: 'Karma Slomianski',
    image: karmaPhoto,
    positionHeld: 'BitFinance, COO',
  },
  KARA_WASSER: {
    fullName: 'Kara Wasser',
    image: karaPhoto,
    positionHeld: 'Dub Diversified LLC, CEO',
  },
  NOAM_EPPEL: {
    fullName: 'Noam Eppel',
    image: noamEppelPhoto,
    positionHeld: 'Co-Founder & COO',
  },
  DARREN_MOON: {
    fullName: 'Darren Moon',
    image: darrenMoonPhoto,
    positionHeld: 'CEO & Co-Founder @Upwealth',
  },
  MARK_VAN_RIJMENAM: {
    fullName: 'Mark van Rijmenam',
    image: markVanRijmenamPhoto,
    positionHeld: '',
  },
  RAJ_NARAYAN: {
    fullName: 'Raj Narayan',
    image: rajNarayaPhoto,
    positionHeld: '',
  },
}

export const CLIENTS_FEEDBACK = [
  {
    id: 'feedbackUpWealth',
    fullName: CLIENTS.DARREN_MOON.fullName,
    image: CLIENTS.DARREN_MOON.image,
    positionHeld: CLIENTS.DARREN_MOON.positionHeld,
    text:
      "What we found most impressive and unique about StartupCraft is their exceptional technical expertise and unwavering commitment to excellence. They consistently demonstrated a deep understanding of our project's complexities and delivered innovative solutions on time and within budget. \n" +
      '\n' +
      '\n' +
      "Their proactive communication, attention to detail, and ability to adapt to evolving requirements truly set them apart. It's their combination of technical prowess and a customer-centric approach that made our collaboration with them both successful and inspiring.\n",
  },
  {
    id: 'feedbackMorpheus',
    fullName: CLIENTS.NOAM_EPPEL.fullName,
    image: CLIENTS.NOAM_EPPEL.image,
    positionHeld: CLIENTS.NOAM_EPPEL.positionHeld,
    text: 'The supply chain masternodes project was a huge success and we have hundreds of users so far. I am especially pleased with the UI/UX of the platform which made onboarding new users a seamless experience.',
  },
  {
    id: 'feedbackSentr3',
    fullName: CLIENTS.IAN_GILMOUR.fullName,
    image: CLIENTS.IAN_GILMOUR.image,
    positionHeld: CLIENTS.IAN_GILMOUR.positionHeld,
    text: 'The Sentr3 team has been incredibly helpful so far. They are extremely reactive, professional, and committed to consistently delivering excellence. Their platform and Web3 knowledge have been and will continue to be instrumental to our core business long-term.',
  },
  {
    id: '24855519',
    fullName: CLIENTS.BRANDON_KLEIN.fullName,
    image: CLIENTS.BRANDON_KLEIN.image,
    positionHeld: CLIENTS.BRANDON_KLEIN.positionHeld,
    text: 'With the client raving about the quality of their work, StartupCraft has performed well during the engagement. They have delivered virtually error-free work and have stuck to the project timeline and budget.',
  },
  {
    id: '24317184',
    fullName: CLIENTS.BRANDON_EVANS.fullName,
    image: CLIENTS.BRANDON_EVANS.image,
    positionHeld: CLIENTS.BRANDON_EVANS.positionHeld,
    text: 'They delivered a high-quality platform with an expediency that impressed investors. The software is intuitive and was positively received by users. StartupCraft’s expert team can accomplish tasks suited for much larger development firms. Executive-level engagement generated a collaborative process.',
  },
  {
    id: '56158746',
    fullName: CLIENTS.CHRIS_DEFOUR.fullName,
    image: CLIENTS.CHRIS_DEFOUR.image,
    positionHeld: CLIENTS.CHRIS_DEFOUR.positionHeld,
    text:
      '"I am impressed with the speed at which their team is able to understand our needs and vision"\n' +
      '\n' +
      'Feedback summary:\n' +
      'Although the project is still ongoing, the client commends the platform for its great performance and functionalities. StartupCraft utilizes various tools to track and share their progress with the client, ensuring a transparent process. They remain flexible, responsive, and accommodating.',
  },
  {
    id: '50678103',
    fullName: CLIENTS.ROSS_HENRY.fullName,
    image: CLIENTS.ROSS_HENRY.image,
    positionHeld: CLIENTS.ROSS_HENRY.positionHeld,
    text:
      '"They make our goals theirs, and that level of dedication and attentiveness represents their work ethic."\n' +
      '\n' +
      "Equipped with unmatched expertise and a strong desire to see their client's business flourish, StartupCraft delivers on-point and on-budget solutions that have led to the birth of a user-friendly platform. The team is quick to apply iterations and is accommodating of their client's requests.",
  },
  {
    id: '24288330',
    fullName: CLIENTS.CHRIS_NORMAN.fullName,
    image: CLIENTS.CHRIS_NORMAN.image,
    positionHeld: CLIENTS.CHRIS_NORMAN.positionHeld,
    text: 'StartupCraft team have been very effective in providing solutions when we had an issue or new feature requests.',
  },
  {
    id: '24288601',
    fullName: CLIENTS.DAVID_KITCHEN.fullName,
    image: CLIENTS.DAVID_KITCHEN.image,
    positionHeld: CLIENTS.DAVID_KITCHEN.positionHeld,
    text: 'StartupCraft was a lifesaver for FantasyInsiders - it saved the life and brand of FantasyInsiders that we had put so much work into. ',
  },
  {
    id: '24288492',
    fullName: CLIENTS.ROBERTO_VELARDE.fullName,
    image: CLIENTS.ROBERTO_VELARDE.image,
    positionHeld: CLIENTS.ROBERTO_VELARDE.positionHeld,
    text: 'Internal reviews for the new site are very positive. StartupCraft worked independently and responded quickly to inquiries. They are consistent communicators and have never missed a deadline thanks to their use of project management tools.',
  },
  {
    id: '24288703',
    fullName: CLIENTS.KRISHNA_SUBRAMANIAN.fullName,
    image: CLIENTS.KRISHNA_SUBRAMANIAN.image,
    positionHeld: CLIENTS.KRISHNA_SUBRAMANIAN.positionHeld,
    text: 'Working with StartupCraft was easy, efficient, and economical. Vlad goes above and beyond to make sure that you’re project is a s success. The only hire the smartest engineers.',
  },
  {
    id: '24288936',
    fullName: CLIENTS.DUSTIN_GRINER.fullName,
    image: CLIENTS.DUSTIN_GRINER.image,
    positionHeld: CLIENTS.DUSTIN_GRINER.positionHeld,
    text: 'This new system developed by StartupCraft completely changed the way we do business.This app was created as an internal tool and it has streamlined our payroll and AR process so much that we are considering changing our entire business model to offer these services to our competitors.',
  },
  {
    id: '24289035',
    fullName: CLIENTS.CHRIS_DEFOUR_2.fullName,
    image: CLIENTS.CHRIS_DEFOUR_2.image,
    positionHeld: CLIENTS.CHRIS_DEFOUR_2.positionHeld,
    text: 'I love working with StartupCraft’s team. They truly care about the quality of the work, and I appreciate how lean and agile they are to meet our clients’ needs.',
  },
  {
    id: '24317186',
    fullName: CLIENTS.AHMED_BAHGAT.fullName,
    image: CLIENTS.AHMED_BAHGAT.image,
    positionHeld: CLIENTS.AHMED_BAHGAT.positionHeld,
    text:
      'My project had diverse features and advanced business logic, I had been looking for, and interviewing many of the well reputed development agencies before settling with StartupCraft team.\n' +
      'What truly engages me with StartupCraft is their enthusiasm and passion to work with promising startups, they also are well equipped to act in high agility with changing requirements, and finally a clear commitment to deliver quality product.\n' +
      'They have provided dedicated expert BA, top notch development team and Quality assurance / testers to ensure smooth and quality delivery from 1st day of engagement.\n' +
      'We continue to release new features very rapidly and the end experience has been smooth and satisfactory.\n' +
      '\n' +
      'Wish them the best in their journey.',
  },
  {
    id: '22626851',
    fullName: CLIENTS.MATHIEU_DIAB.fullName,
    image: CLIENTS.MATHIEU_DIAB.image,
    positionHeld: CLIENTS.MATHIEU_DIAB.positionHeld,
    text: 'StartupCraft built an exceptional app, streamlining a variety of processes for clients and their employees. Higher ups have even expressed an interest in white-labeling the platform, proving its value and potential. Working with their team is not only a seamless process, but also a pleasure.',
  },
  {
    id: '24286099',
    fullName: CLIENTS.KARMA_SLOMIANSKI.fullName,
    image: CLIENTS.KARMA_SLOMIANSKI.image,
    positionHeld: CLIENTS.KARMA_SLOMIANSKI.positionHeld,
    text: 'Developments helped secure pre-seed fundraising; the quality exceeded expectations. Communication was both precise and smooth, despite their being offshore, and deadlines were always met.',
  },
  {
    id: '24219005',
    fullName: CLIENTS.KARA_WASSER.fullName,
    image: CLIENTS.KARA_WASSER.image,
    positionHeld: CLIENTS.KARA_WASSER.positionHeld,
    text: 'The app has exceeded the expectations of the internal team. StartupCraft continues to provide updates and support to the platform, communicating effectively. Their team goes above and beyond to provide quality customer service.',
  },
  {
    id: 'futur-wise-feedback',
    fullName: CLIENTS.MARK_VAN_RIJMENAM.fullName,
    image: CLIENTS.MARK_VAN_RIJMENAM.image,
    positionHeld: CLIENTS.MARK_VAN_RIJMENAM.positionHeld,
    text:
      '"Their development speed and accuracy were impressive."\n\n' +
      'Much to the delight of the client, the resulting app aligned with their requirements and was launched successfully. StartupCraft managed the whole project well and boasted the ability to deliver reliable services without compromising the quality of their outputs.',
  },
  {
    id: 'emajin-golf-feedback',
    fullName: CLIENTS.RAJ_NARAYAN.fullName,
    image: CLIENTS.RAJ_NARAYAN.image,
    positionHeld: CLIENTS.RAJ_NARAYAN.positionHeld,
    text: "StartupCraft's fast communication has allowed for efficient changes and updates. The team's methodical milestone approach has meant that current and future functionality roll-outs were mapped and executed as planned. Overall, the team has gone above and beyond to achieve the client's goals.",
  },
]

export const BLOCKCHAIN_TESTIMONIALS = CLIENTS_FEEDBACK
